import Axios from 'axios'
import React, { useState, useCallback, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { CardGroup } from 'reactstrap'
import styles from './BySubCat.module.css'
import { API_URL } from '../../ApiUrl.js'

function BySubCat() {
  let { typeId, catId, subCatId } = useParams()
  const [arts, setArts] = useState([])
  const [error, setError] = useState('')
  const [cat, setCat] = useState('')
  const [type, setType] = useState('')
  const [subCat, setSubCat] = useState('')

  const getArtsBySubCat = useCallback(async () => {
    try {
      const res = await Axios.get(`${API_URL}/api/sculptures`)
      const artsBySubCat = res.data
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .filter(
          (item) =>
            item.SousCategoryId === subCatId &&
            item.CategoryId === catId &&
            item.TypeId === typeId
        )
      
      if (artsBySubCat.length > 0) {
        setType(artsBySubCat[0].Type.label)
        setCat(artsBySubCat[0].Category.label)
        setSubCat(artsBySubCat[0].SousCategory.label)
        setArts(artsBySubCat)
      }
    } catch (err) {
      setError("Erreur lors du chargement des œuvres")
    }
  }, [catId, subCatId, typeId])

  useEffect(() => {
    getArtsBySubCat()
  }, [getArtsBySubCat])

  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className={styles.bySubCatStyle}>
      {error && <p className="text-danger text-center">{error}</p>}
      
      <div className="text-center mt-3">
        <h3 className="title-centered">{type}</h3>
        <h2 className="title-centered">{cat}</h2>
        <h1 className="title-centered-no-margin-top">{subCat}</h1>
      </div>

      <CardGroup className={styles.cardGroup}>
        {arts.map((item) => (
          <div key={item.id} className={styles.cardSizeSubCat}>
            <Link to={`/galery/${typeId}/${catId}/sc/${subCatId}/${item.id}`} onClick={handleScrollToTop}>
              <img
                className={styles.imageSubCat}
                src={item.imageUrl}
                alt={item.title || "Oeuvre"}
              />
            </Link>
          </div>
        ))}
      </CardGroup>
    </div>
  )
}

export default BySubCat
